export default {"src":"/_next/static/media/error-free-3.5d59e06f.svg","height":47,"width":41,"blurWidth":0,"blurHeight":0};